(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["slide-with-text"] && !Shopify.designMode) return;
  try {
    
class SimpleSlider {
  constructor(container) {
    this.container = container;
    this.slideIndex = 1;
    this.slides = container.querySelectorAll(".mySlides");
    this.dots = container.querySelectorAll(".dot");
    this.prev = container.querySelector(".prev");
    this.next = container.querySelector(".next");

    // Inicializar el primer slide
    this.showSlides(this.slideIndex);

    // Eventos de botones
    if (this.prev) this.prev.addEventListener("click", () => this.plusSlides(-1));
    if (this.next) this.next.addEventListener("click", () => this.plusSlides(1));

    // Eventos dots
    this.dots.forEach((dot, i) =>
      dot.addEventListener("click", () => this.currentSlide(i + 1))
    );
  }

  plusSlides(n) {
    this.showSlides(this.slideIndex + n);
  }

  currentSlide(n) {
    this.showSlides(n);
  }

  showSlides(n) {
    if (n > this.slides.length) n = 1;
    if (n < 1) n = this.slides.length;
    this.slideIndex = n;
    this.slides.forEach(slide => slide.style.display = "none");
    this.dots.forEach(dot => dot.classList.remove("active"));
    this.slides[this.slideIndex - 1].style.display = "block";
    this.dots[this.slideIndex - 1].classList.add("active");
  }
}

// Inicializar todos los slideshows
document.querySelectorAll(".slide-container").forEach(container => {
  new SimpleSlider(container);
});

  } catch(e) { console.error(e); }
})();
})();
